<header class="header-like-campus">
  <div class="content-like-campus">
    <div class="header-like-campus--components">
      <div class="header-like-campus__logowrap">
        <img
          class="header-like-campus__logo"
          src="https://min.gamelearn.io/css-resources/gamelearn/resources/campus/logo-gamelearn.svg"
        />
      </div>
      <a routerLink="/login" role="button" class="header-like-campus__logout">
        <span class="glicon-logout"></span>
        <span>{{ 'actions.logOut' | translate }}</span>
      </a>
    </div>
  </div>
</header>
<main class="main--campus main--campus--clients-selector" role="main">
  <div class="content-like-campus">
    <div class="clients-selector">
      <div class="clients-selector__content">
        <img
          class="clients-selector__campuslogo"
          src="https://min.gamelearn.io/css-resources/gamelearn/resources/campus/logo-campus.svg"
          alt="Campus"
        />
        <h1 class="clients-selector__title">{{ 'clientSelector.title' | translate }}</h1>
        <div class="clients-selector__subtitle">
          {{ 'clientSelector.subtitle' | translate }}
          <b *ngIf="clientsList[0]">{{ clientsList[0].email }}</b>
        </div>
        <div *ngIf="error">
          <p class="error">
            {{ 'nouns.error' | translate }}: {{ 'apiErrors.' + error.errorCode | translate }}.
          </p>
          <a routerLink="/login" role="button">{{ 'actions.logInAgain' | translate }}</a>
        </div>
        <ul class="clients-selector__cards">
          <li
            class="clients-selector__card buttons-design-system"
            *ngFor="let client of clientsList"
            (click)="handleSelectUser(client.clientId)"
          >
            <div class="clients-selector__user">
              <div class="clients-selector__avatar">
                <img *ngIf="client.logo" [src]="client.logo" alt="" />
                <div *ngIf="!client.logo" class="clients-selector__initial">
                  <span>G</span>
                </div>
              </div>
              <div class="clients-selector__username">
                <div class="u-text-ellipsis">
                  {{ client.clientName }}
                </div>
              </div>
            </div>
            <div class="clients-selector__button btn btn--primary">
              {{ 'clientSelector.select' | translate }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</main>
